import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import catalogIcon from 'Images/catalog_icon.svg';
import { Box, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import FullScreenDialog from 'Shared/FullModal';
import { WithRolesComponent } from 'HOC/withRoles';
import { ReactComponent as Logo } from '../../Images/logo_bar.svg';
import SearchBar from './SearchBar';
import AdminLinks from './AdminLinks';
import UserSection from './UserSection';
import DrawerMenu from './DrawerMenu';
import ProfileInfo from './ProfileInfo';
import ChangePasswordBody from './ChangePasswordBody';
import { pages, ACCOUNT_PAGE } from './constants';

const Navbar = () => {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalPwd, setOpenModalPwd] = useState(false);

  const navTo = (to) => { if (to) history.push(to); };

  return (
    <>
      <FullScreenDialog open={openModal} setOpen={setOpenModal}>
        <ProfileInfo onClose={() => setOpenModal(false)} />
      </FullScreenDialog>
      <FullScreenDialog open={openModalPwd} setOpen={setOpenModalPwd}>
        <ChangePasswordBody onClose={() => setOpenModalPwd(false)} />
      </FullScreenDialog>

      <AppBar
        position="fixed"
        sx={{
          backgroundColor: '#FFFFFF',
          border: '1px solid #E6E7EA',
          boxShadow: 'none',
          height: '70px',
          justifyContent: 'center',
        }}
      >
        <Toolbar
          sx={{
            px: { xs: '16px', md: '40px' },
            my: '8px',
            mx: 0,
            minHeight: '70px !important',
            height: '70px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          {/* Mobile hamburger */}
          <IconButton
            onClick={() => setIsOpen(true)}
            sx={{ color: '#007bc6', display: { xs: 'flex', md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <DrawerMenu
            navTo={navTo}
            pages={[...pages, ACCOUNT_PAGE]}
            setIsOpen={setIsOpen}
            isOpen={isOpen}
            setOpenModalPwd={setOpenModalPwd}
            setOpenModal={setOpenModal}
          />

          {/* Logo */}
          <Logo
            onClick={() => navTo('/')}
            style={{
              width: '110px', height: 'auto', cursor: 'pointer', flexShrink: 0,
            }}
          />

          <WithRolesComponent allowedRoles={['ROLE_CLIENT']}>
            <SearchBar />
          </WithRolesComponent>
          <AdminLinks navTo={navTo} />
          <WithRolesComponent allowedRoles={['ROLE_ADMIN']}>
            <Box sx={{ flex: 1 }} />
          </WithRolesComponent>

          {/* Right group: Catalogue + User pill — fixed to right edge */}
          <Box sx={{
            display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0,
          }}
          >
            <WithRolesComponent allowedRoles={['ROLE_CLIENT']}>
              <Box
                onClick={() => navTo('/catalog')}
                sx={{
                  height: '48px',
                  width: '157px',
                  background: '#F8FAFC',
                  border: '1px solid #DEE5EE',
                  borderRadius: '8px',
                  display: { xs: 'none', md: 'flex' },
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  cursor: 'pointer',
                  flexShrink: 0,
                  '&:hover': { background: '#EEF2F7' },
                  px: '32px',
                  py: '8px',
                }}
              >
                <img src={catalogIcon} alt="catalogue" style={{ width: 26, height: 20, objectFit: 'contain' }} />
                <Typography sx={{ fontSize: 16, fontWeight: 600, color: '#385576' }}>
                  Catalogue
                </Typography>
              </Box>
            </WithRolesComponent>
            <UserSection setOpenModal={setOpenModal} setOpenModalPwd={setOpenModalPwd} />
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Navbar;
